/* eslint-disable no-undef */
function heapAddUserProperties(props) {
  heap.addUserProperties(props);
}

export { heapAddUserProperties };
